const normalizeRoom = (room) => String(room || '').trim().toUpperCase().replace(/[\s-]/g, '');

// Room order, numeric-aware ("402" before "1010"), then most recently updated.
export function sortPatients(patients) {
  return [...patients].sort((a, b) => {
    const byRoom = normalizeRoom(a.room).localeCompare(normalizeRoom(b.room), undefined, { numeric: true });
    if (byRoom !== 0) return byRoom;
    return String(b.updatedAt || '').localeCompare(String(a.updatedAt || ''));
  });
}

// Matches patient name (any word order), room or MRN, ignoring case, and
// spaces and dashes in rooms and MRNs.
export function filterPatients(patients, query) {
  const q = query.trim().toLowerCase();
  if (!q) return patients;
  const roomQuery = normalizeRoom(q);
  return patients.filter((p) => {
    const name = String(p.name || '').toLowerCase();
    const nameMatch = q.split(/\s+/).every((term) => name.includes(term));
    const roomMatch = roomQuery !== '' && normalizeRoom(p.room).includes(roomQuery);
    const mrnMatch = roomQuery !== '' && normalizeRoom(p.mrn).includes(roomQuery);
    return nameMatch || roomMatch || mrnMatch;
  });
}
